import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withFirestore } from 'react-redux-firebase';
import { acceptMatch, rejectMatch } from '../../../store/actions/dealActions';
import {
  text__primary,
  text__primary_dark,
  white,
  deepPurple,
  grey,
  grey_dark,
  text__secondary
} from '../../../style';
import {
  getCampaignsCount,
  getCampaignsLoaded
} from '../../../store/selectors/campaigns';

const styles = theme => ({
  root: {
    width: '100%',
    padding: '30px',
    marginBottom: '30px'
  },
  layout: {
    width: 'auto',
    background: '#f5f6fa',
    paddingTop: theme.spacing.unit * 7,
    paddingBottom: theme.spacing.unit * 10,
    paddingLeft: theme.spacing.unit * 4,
    paddingRight: theme.spacing.unit * 4,
    [theme.breakpoints.up(600 + theme.spacing.unit * 4 * 2)]: {
      width: '100%',
      boxSizing: 'border-box'
    }
  },
  descriptionContainer: {
    marginTop: '30px',
    maxHeight: '100px',
    overflow: 'hidden'
  },
  tableCell: {
    paddingTop: '30px',
    paddingBottom: '30px'
  },
  icon: {
    color: 'red',
    width: '25px',
    height: '25px'
  },
  title: {
    color: deepPurple,
    marginBottom: '30px'
  },
  expandPanel: {
    boxShadow: 'none'
  },
  tableRow: {
    cursor: 'pointer'
  },
  acceptButton: {
    minWidth: '150px',
    display: 'block',
    color: white
  },
  rejectButton: {
    width: '150px',
    display: 'block'
  },
  linkStyle: {
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  dropdown: {
    marginBottom: '50px',
    width: '250px'
  },
  select: {
    marginBottom: '50px',
    width: '250px',
    marginTop: '0px',
    background: white,
    '& > *': {
      maxWidth: 500,
      width: '100%',
      margin: '0 auto'
    }
  },
  selectMenu: {
    '& .MuiPopover-paper': {
      maxHeight: 250
    }
  },
  noCurrentOffers: {
    height: '150px'
  },
  noOffersContainer: {
    marginTop: '55px'
  },
  createCampLink: {
    color: '#22c26e',
    display: 'inline',
    fontSize: '1em'
  },
  circleImage: {
    objectFit: 'cover',
    borderRadius: '50%',
    width: '96px',
    height: '96px'
  },
  influencerName: {
    marginLeft: '10px'
  }
});

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
    matchesPending: state.firestore.ordered.deals,
    campaignsCount: getCampaignsCount(state),
    campaignsLoaded: getCampaignsLoaded(state)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    acceptMatchHandler: match => dispatch(acceptMatch(match, ownProps)),
    rejectMatchHandler: match => dispatch(rejectMatch(match, ownProps))
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFirestore,
  withProps(({ profile, auth }) => ({
    profile,
    auth
  })),
  withStyles(styles),
  // Add props.router (used in handlers)
  withRouter
);



// WEBPACK FOOTER //
// ./src/components/company/match-feed/CompanyMatchFeed.enhancer.js